import { useEffect,useState,Suspense } from 'react';
import {Chart,Ad1,Ad2,Ad3,Ad4,Loader,Video1,Video2} from '../';
import {Card,Row,Typography,Button,Tag} from 'antd';
import moment from 'moment';
import i18next from 'i18next';
import ErrorImage from '../../img/og-image.jpg'
import axios from 'axios';
import 'moment/locale/zh-cn';
import './Home.css';
import { Gpt } from 'react-gpt-ads';
import zhConvertor from 'zhconvertor';

moment().locale('zh-cn')

const {Text,Title}=Typography;

const Home = () => {
  const [article,setArticle]=useState([]);
  const [gallery,setGallery]=useState([]);
  const [pinNews,setPinNews]=useState([]);
  const [load,setLoad]=useState(25);
  const [done,setDone]=useState(undefined);
  const [iframe1,setIFrame1]=useState('');
  const [iframe2,setIFrame2]=useState('');
  const [iframe3,setIFrame3]=useState('');
  const [focusSeat,setFocusSeat]=useState('');
  const [focusHuman,setFocusHuman]=useState('');
  const replaceErrorImg=e=>{
    e.target.onerror=null;
    e.target.src=ErrorImage;
  }

  const [newsRoll, setNewsRoll] = useState([]);
  
 
  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  let latestTime = 0;

  const fetchNewsRoll = async () => {
    if (window.liveRoll && window.liveRoll != "" && window.liveRollID && window.liveRollID != "") {
      try {
        
        //post request
        const response = await axios.post(window.liveRoll, {
          i: window.liveRollID,
          l: 3,
          t: latestTime
        });

        latestTime = 1;
        //console.log("response: " + JSON.stringify(response));
        const data = response.data.rolls;
        console.log("data: " + data);
        setNewsRoll(data);

        setTimeout(
          fetchNewsRoll
          , window.liveRollInterval
        )
      } catch (error) {
        console.error("Error fetching news roll:", error);
      }
    }
  }

  const fetchData=async()=>{
      
    var rand = Math.random() * 100;

    let lang = localStorage.getItem('lang') || 'zh_CN';

    axios.get('article_with_gallery.php?lang=' + lang).then((response)=>{
        const pinsData=response.data.pins;
        setPinNews(pinsData);
        const articleData=response.data.articles;
        setArticle(articleData);
        const galleryData=response.data.gallery;
        setGallery(galleryData);
        setDone(true);
      })

      // get content from an url using Promise
      
    await fetch(
      "https://sabah2025.orientaldaily.com.my/cache/pinvid.txt?i=" + rand 
    ).then(response => response.text()).then(data => { setIFrame1(data)});
    await fetch(
      "https://sabah2025.orientaldaily.com.my/cache/pinvid2.txt?i=" + rand
      ).then(response => response.text()).then(data => { setIFrame2(data)});
    /*await fetch(
        "https://sabah2025.orientaldaily.com.my/cache/album.txt?i=" + rand
        ).then(response => response.text()).then(data => { setIFrame3(data)});*/
    await fetch(
      "https://sabah2025.orientaldaily.com.my/cache/focusseat.txt?i=" + rand
      ).then(response => response.text()).then(data => { 
        
        var data_arr = data.split(/\r?\n/);
        /*
        result.forEach(element => {
          console.log("element: " + element);
        });
        */
       
        setFocusSeat(data_arr);
      });
    /*await fetch(
        "https://sabah2025.orientaldaily.com.my/cache/focushuman.txt?i=" + rand
        ).then(response => response.text()).then(data => { 
          
        var data_arr = data.split(/\r?\n/);
        setFocusHuman(data_arr);
        });*/
  }

  function timestampToTime(timestamp){
    const timestampInMs = timestamp * 1000;

    // Create a new Date object
    const dateObject = new Date(timestampInMs);

    // Extract hours, minutes, and seconds
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const seconds = dateObject.getSeconds();

    // Format the time (add leading zeros if necessary)
    const formattedHours = hours < 10 ? '0' + hours : hours;
    const formattedMinutes = minutes < 10 ? '0' + minutes : minutes;
    const formattedSeconds = seconds < 10 ? '0' + seconds : seconds;

    return formattedHours + ":" + formattedMinutes;
  }

  function getCurrentDimension(){
    return {
      	width: window.innerWidth,
      	height: window.innerHeight
    }
  }
  useEffect(()=>{
    fetchData();

    if(window.liveRoll !=""){
      fetchNewsRoll();
    }
  },[])
  useEffect(() => {
    const updateDimension = () => {
      setScreenSize(getCurrentDimension())
    }
    window.addEventListener('resize', updateDimension);
    
    return(() => {
        window.removeEventListener('resize', updateDimension);
    })
  }, [screenSize])
  if (!done) return <Loader/>;
  return (
    <>
    <div className="home-page">
      {window.innerWidth <= 480 ? <img alt="sabah2025" className="mainbanner" src="/flags/sabahbanner_mobile.jpg" /> : <img className="mainbanner" alt="sabah2025" src="/flags/sabahbanner_desktop.jpg" />
      }
      {/*only display the div after 29/11/2025*/
      Date.now() >= new Date('2025-11-29T00:00:00').getTime() &&
        <div>
          <div className='div_chart'>
            <div className='state_name'>{i18next.t('state_7')}（73 席）</div>
            <Chart
              stateId={1}
              totalSeats={73}
            />
          </div>
        </div>
      }
          <Suspense fallback={<Loader/>}>
            
          </Suspense>
          <Gpt 
              adUnit="/2163006/election2023_top"
              name="div-gpt-ad-1666944904129-0"
              size={[[300, 250],[336, 280], 'fluid']}
          />
      
          {newsRoll && newsRoll.length > 0 ? 
              <div className="newsroll">
                <div className="newsrolltitle">{i18next.t("滚动新闻")}</div>
                {newsRoll.map((eachRoll, i) => {
                  return (
                    <div key={i} className="eachroll">
                      <div className="rollmeta">{timestampToTime(eachRoll.t)}</div>
                      <div className="rollcontent" dangerouslySetInnerHTML={{__html: eachRoll.c}}></div>
                    </div>
                  );
                })}
                <a className="morerollsa" rel="noopener" href={window.liveRollFullURL}><div className="morerolls">{i18next.t("完整滚动新闻")}</div></a>
              </div>

            : null
          }

          {pinNews && pinNews.length > 0 && pinNews.map((pin,index)=> {
            return(
              <Row key={index} style={{marginBottom:'1em'}}>
                <Card className="article-news">
                  <a href={pin.url} target="_blank" rel="noreferrer">
                    <div className="news-image-container">
                        <div>
                          <img src={pin.picurl} className='news-image' alt={pin.id} onError={replaceErrorImg}/>
                        </div>
                        <div className='article-text'>
                          <Title className='news-title' level={5}>{pin.title}</Title>
                          <Text className='news-date'>{moment(pin.date).fromNow()}</Text>
                          <Tag className="pin-news"color="red" style={{marginLeft:"1em",borderColor:'white'}}>{i18next.t("热闻")}</Tag>
                          <Text className='news-text' style={{marginTop:'1em'}}>{pin.description.length>100 ? `${pin.description.substring(0,50)}...` : pin.description}</Text>
                        </div>  
                    </div>
                  </a>
                  <hr className='article-divider'/>
                </Card>
              </Row>
            )
          })}

          {article && article.slice(0,load).map((art,index)=>(
            <Row key={index}>
              {index == 7 ? 
                <Gpt 
                  adUnit="/2163006/election_336x280_300x250"
                  name="div-gpt-ad-1599627962119-0"
                  size={[[300, 250],[336, 280], 'fluid']}
                  style={{margin:"1em auto"}}
              /> : null
              }
              {index == 14 ? 
                <Gpt 
                  adUnit="/2163006/election_336x280_300x250_2"
                  name="div-gpt-ad-1599823689403-0"
                  size={[[300, 250],[336, 280]]}
              /> : null
              }
              {index == 21 ? 
                <Gpt 
                  adUnit="/2163006/election_336x280_300x250"
                  name="div-gpt-ad-1599907131243-0"
                  size={[[300, 250],[336, 280], 'fluid']}
              /> : null
              }
              {/*index===7 && <Ad1/>}
              {index===14 && <Ad2/>}
          {index===21 && <Ad3/>*/}
              

              {index == 2 && focusSeat != "" && (
                <div className="focus-section">
                  <div className="section-title">{i18next.t("选战热话")}</div>
                  <ul className="focus-section-ul">
                  {
                    focusSeat.map((eachFocus, i) => {
                      //console.log("eachFocus: "  + eachFocus);
                      return(
                      <li key={i}><a href={"https://www.orientaldaily.com.my/news/browse/" + i18next.t(eachFocus)}>
                        <div key={i} className="each-focus">{localStorage.getItem('lang') != 'zh_TW' ?zhConvertor.t2s(eachFocus) : eachFocus}</div>
                        </a>
                      </li>)
                    })
                    
                  }
                  </ul>
                  
                </div>
                
              )}

              {index == 8 &&
               <div style={{textAlign: "center", margin:"0 auto 1em auto"}}><a className="morerollsa" rel="noopener" href="https://sabah2025.orientaldaily.com.my/seats/sabah/n"><div className="morerolls">{i18next.t("议席列表")}</div></a></div>
              }

              {index == 2 && iframe1.trim() != "" && (
                <div className="player-wrapper" dangerouslySetInnerHTML={{__html: iframe1}}>
                </div>
              )}
              {index == 6 && iframe2.trim() != "" && (
                <div className="player-wrapper" dangerouslySetInnerHTML={{__html: iframe2}}>
                </div>
              )}
              {index == 12 && iframe3.trim() != "" && (
                <div className="album-wrapper" dangerouslySetInnerHTML={{__html: iframe3}}>
                </div>
              )}

              {index == 20 && (
                <div className="apps-wrapper">
                  <div className="section-title">{i18next.t("东方网 APP")}</div>
                  <div className="apps-download">
                    <a href="https://apps.apple.com/us/app/oriental-daily-%E4%B8%9C%E6%96%B9%E6%97%A5%E6%8A%A5-%E9%A9%AC%E6%9D%A5%E8%A5%BF%E4%BA%9A%E7%83%AD%E7%82%B9%E6%96%B0%E9%97%BB/id1550134045" target="_blank" rel="noreferrer">
                      <img alt="App Store" src="/img/appleappstore.png" className="appstore-image"/>
                    </a>
                    <a href="https://play.google.com/store/apps/details?id=com.my.orientaldailynews" target="_blank" rel="noreferrer">
                      <img alt="Google Play" src="/img/googleplay.png" className="googleplay-image"/>
                    </a>
                    <a href="https://appgallery.huawei.com/#/app/C103900095" target="_blank" rel="noreferrer">
                      <img alt="App Gallery" src="/img/huaweiappgallery.png" className="appgallery-image"/>
                    </a>
                  </div>
                </div>
              )}

              {/*index == 5 && focusHuman != "" && (
                <div className="focus-section">
                  <div className="section-title">{i18next.t("焦点人物")}</div>
                  <ul className="focus-section-ul">
                  {
                    focusHuman.map((eachFocus, i) => {
                      return(
                        <li><a href={"https://www.orientaldaily.com.my/news/browse/" + i18next.t(eachFocus)}>
                          <div key={i} className="each-focus">{eachFocus}</div>
                          </a>
                        </li>)
                    })
                    
                  }
                  </ul>
                </div>
                )*/}
                {art.type === "gallery" ? 
                  <Card className="article-news">
                    <a href={art.url} target="_blank" rel="noreferrer">
                      <div className="gallery-container">
                        <div className='article-text'>
                          <Title className='news-title' level={5}>{art.title}</Title>
                          <Text className='news-date'>{moment(art.date).fromNow()}</Text>
                          <Tag className="pin-news"color="red" style={{marginLeft:"1em",borderColor:'white'}}>{i18next.t("图集")}</Tag>
                        </div>  
                      </div>
                    </a>
                    <div className="gallery-grid">
                      {/*
                      gallery json
                      {
                        "title": "沙巴州選舉大混戰  596人角逐73議席",
                        "date": "2025-11-15 19:51",
                        "images": [
                          "https://media5.orientaldaily.com.my/images/uploads/news-cover/2025/NOV_2025/20251115/1115_Sabah_Vote_Data-1.png"
                        ]
                      } */}
                      {gallery[art.id] && gallery[art.id].images.map((imgSrc,idx)=>(
                        <div key={idx} className="gallery-image-wrapper">
                          <img src={imgSrc} alt={`${art.id}-${idx}`} className="gallery-image" />
                        </div>
                      ))} 
                    </div>
                    <hr className='article-divider'/>
                  </Card>
                  :
                  <Card className="article-news">
                  <a href={art.url} target="_blank" rel="noreferrer">
                    <div className="news-image-container">
                        <div>
                          <img src={art.picurl} className='news-image' alt={art.id} onError={replaceErrorImg}/>
                        </div>
                        <div className='article-text'>
                          <Title className='news-title' level={5}>{art.title}</Title>
                          <Text className='news-date'>{moment(art.date).fromNow()}</Text>
                          {art.pinnews && (<Tag className="pin-news"color="red" style={{marginLeft:"1em",borderColor:'white'}}>{i18next.t("热闻")}</Tag>)}
                          <Text className='news-text' style={{marginTop:'1em'}}>{art.description.length>100 ? `${art.description.substring(0,50)}...` : art.description}</Text>
                        </div>  
                    </div>
                  </a>
                  <hr className='article-divider'/>
                </Card>
              }
            </Row>
            )
            )
          }

    </div>
    <div className='load-page'>
      <Button className='load-button' type="primary" style={{marginBottom:'3em',backgroundColor:'#cb0c13',borderColor:'#cb0c13',height:'auto',fontSize:'15px',padding:'14px 50px'}}onClick={()=>setLoad((preLoad)=>preLoad+10)}>更多文章</Button>
    </div>
    {navigator.share &&
      <div className="floating-share-button" onClick={()=>{
        navigator.share({
          title: '沙巴州选 2025 - 东方网 马来西亚东方日报',
          text: '获取马来西亚沙巴州选 2025 的最新消息',
          url: window.location.href
        })
      }}>
        
      </div>
    }
    </>
  )
}
export default Home 